import { render, staticRenderFns } from "./BrochuresSection.vue?vue&type=template&id=515c0811&"
import script from "./BrochuresSection.vue?vue&type=script&lang=js&"
export * from "./BrochuresSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515c0811')) {
      api.createRecord('515c0811', component.options)
    } else {
      api.reload('515c0811', component.options)
    }
    module.hot.accept("./BrochuresSection.vue?vue&type=template&id=515c0811&", function () {
      api.rerender('515c0811', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/BrochuresSection.vue"
export default component.exports